import { LoginError } from "errors/login-error";
import { Dispatch, SetStateAction, useEffect } from "react";
import useLocation, { usePathname } from "wouter/use-location";

export function useEffectError(error: string | undefined, setError: Dispatch<SetStateAction<string | undefined>>) {
  const [, setLocation] = useLocation();
  const pathname = usePathname();

  useEffect(() => {
    if (error?.startsWith("ERR_")) {
      setError(LoginError.CODES[error]);
      setLocation(pathname);
    }
  }, [error]);
}
